import LetterDisplay from "../views/LetterDisplay.svelte";
import Main from "../views/Main.svelte";
import Login from "../views/auth/Login.svelte";

export const Routes = {
  "/": Main,
  "/login": Login,
  "/letters/:letter?": LetterDisplay,
  "/nature": LetterDisplay,
  "/nature/*": LetterDisplay,
  "/nature/:topic/:subtopic/:from?": LetterDisplay,
  "/culture": LetterDisplay,
  "/culture/*": LetterDisplay,
  "/culture/:topic/:subtopic/:from?": LetterDisplay,
  "/world": LetterDisplay,
  "/world/*": LetterDisplay,
  "/world/:topic/:subtopic/:from?": LetterDisplay,
  "*": Main,
};
